export default {
  journeys: [],
  pagination: {},
  journey: null,
  nodes: [],
  selectedNodeId: null,
  dirty: false,
  loading: false,
  saving: false,
  // Reference data
  emailTemplates: [],
  waTemplates: [],
  statuses: [],
  groups: [],
  tags: [],
  forms: [],
  journeysList: [],
  fieldTypes: [],
  refStatuses: {},
  formConditionFields: [],
  followUpRules: [],
  // Analytics
  analytics: {
    metrics: {},
    funnel: [],
    entries: [],
    nodeStats: [],
    logs: { data: [], total: 0 }
  }
}
